const defaultState = {
  answer: null,
  isSaving: false,
}

export default defaultState
